<template>
  <span id="count-down-container">{{ currentIndex }}</span>
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    defaultStartIndex: {
      type: Number,
      default: 60,
    },
    defaultStep: {
      type: Number,
      default: 1,
    },
    defaultDuration: {
      type: Number,
      default: 1000,
    },
    defaultEndIndex: {
      type: Number,
      default: 0,
    },
    onEnd: {
      type: Function,
      default: null,
    },
    onStart: {
      type: Function,
      default: null,
    },
    onAbort: {
      type: Function,
      default: null,
    },
    trigger: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    trigger (value) {
      if (value) {
        this.startTimer()
      }

      if (!value && this.currentIndex > this.endIndex) {
        this.stopTimer(this.onAbort || this.onEnd)
      }
    },
  },
  data () {
    return {
      startIndex: 0,
      endIndex: 0,
      duration: 0,
      step: 0,
      timer: null,
      currentIndex: 0,
    }
  },
  methods: {
    clearTimer () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    startTimer () {
      this.clearTimer()
      if (typeof this.onStart === 'function') {
        this.onStart()
      }
      this.countDown(this.startIndex)
    },
    stopTimer (callback) {
      this.clearTimer()
      if (typeof callback === 'function') {
        callback()
      }
      this.currentIndex = this.startIndex
    },
    countDown (index) {
      const newIndex = index - this.step
      if (newIndex >= this.endIndex) {
        this.timer = setTimeout(() => {
          this.currentIndex = newIndex
          this.countDown(newIndex)
        }, this.duration)
      } else {
        this.stopTimer(this.onEnd)
      }
    },
  },
  mounted () {
    this.startIndex = this.defaultStartIndex
    this.endIndex = this.defaultEndIndex
    this.duration = this.defaultDuration
    this.step = this.defaultStep
    this.currentIndex = this.defaultStartIndex
  },
  beforeDestroy () {
    this.clearTimer()
  },
}
</script>
